import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { toAbsoluteUrl } from "../../../utils/CommonHelper";
import { getCookie } from "../../slidebar/components/DarkMode";

export const TelegramBindModal = ({ setShow, show }) => {
  const [mode, setMode] = useState(getCookie("selectedTheme"));

  const handleClose = () => setShow(false);

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      data-bs-theme={mode}
      className="zIndex-9999"
      backdropClassName="zIndex-9999"
    >
      <Modal.Header closeButton>
        <Modal.Title>Notice / 注意</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column gap-3 text-font3 p-2">
          <div>
            <img
              className="w-100"
              src={toAbsoluteUrl(
                `/image/tele1.webp`
              )}
              alt=""
            />
          </div>
          <div>
            需要獲取玩家進出分數請求？請點擊 "Telegram List" 進行綁定。綁定完成后，系統會自動發送進出分數給予所綁定的 Telegram 賬號
          </div>
          <div>
            To receive player entry and exit score requests, please click ‘Telegram List’ to bind your account. After binding is completed, the system will automatically send entry and exit scores to the linked Telegram account.
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleClose}
        >
          Close / 關閉
        </button>
      </Modal.Footer>
    </Modal>
  );
};
